import { differenceInSeconds } from 'date-fns'
import fscreen from 'fscreen';
import moment from "moment";

export const convertHexToRGB = (hex) => {
    // check if it's a rgba
    if (hex.match('rgba')) {
        let triplet = hex.slice(5).split(',').slice(0, -1).join(',')
        return triplet
    }

    let c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')

        return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')
    }
}

export function debounce(func, wait, immediate) {
    var timeout
    return function () {
        var context = this,
            args = arguments
        clearTimeout(timeout)
        timeout = setTimeout(function () {
            timeout = null
            if (!immediate) func.apply(context, args)
        }, wait)
        if (immediate && !timeout) func.apply(context, args)
    }
}

export function isMobile() {
    if (window) {
        return window.matchMedia(`(max-width: 767px)`).matches
    }
    return false
}

export function isMdScreen() {
    if (window) {
        return window.matchMedia(`(max-width: 1199px)`).matches
    }
    return false
}

export function scrollToTop() {
    let ele = document.getElementsByClassName('scroll-y')[0];
    ele.scrollTo(0, 0);
}

function currentYPosition(elm) {
    if (!window && !elm) {
        return
    }
    if (elm) return elm.scrollTop
    // Firefox, Chrome, Opera, Safari
    if (window.pageYOffset) return window.pageYOffset
    // Internet Explorer 6 - standards mode
    if (document.documentElement && document.documentElement.scrollTop)
        return document.documentElement.scrollTop
    // Internet Explorer 6, 7 and 8
    if (document.body.scrollTop) return document.body.scrollTop
    return 0
}

function elmYPosition(elm) {
    var y = elm.offsetTop
    var node = elm
    while (node.offsetParent && node.offsetParent !== document.body) {
        node = node.offsetParent
        y += node.offsetTop
    }
    return y
}

export function scrollTo(scrollableElement, elmID) {
    var elm = document.getElementById(elmID)

    if (!elmID || !elm) {
        return
    }

    var startY = currentYPosition(scrollableElement)
    var stopY = elmYPosition(elm)

    var distance = stopY > startY ? stopY - startY : startY - stopY
    if (distance < 100) {
        scrollTo(0, stopY)
        return
    }
    var speed = Math.round(distance / 50)
    if (speed >= 20) speed = 20
    var step = Math.round(distance / 25)
    var leapY = stopY > startY ? startY + step : startY - step
    var timer = 0
    if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
            setTimeout(
                (function (leapY) {
                    return () => {
                        scrollableElement.scrollTo(0, leapY)
                    }
                })(leapY),
                timer * speed
            )
            leapY += step
            if (leapY > stopY) leapY = stopY
            timer++
        }
        return
    }
    for (let i = startY; i > stopY; i -= step) {
        setTimeout(
            (function (leapY) {
                return () => {
                    scrollableElement.scrollTo(0, leapY)
                }
            })(leapY),
            timer * speed
        )
        leapY -= step
        if (leapY < stopY) leapY = stopY
        timer++
    }
    return false
}

export function getTimeDifference(date) {
    let difference = differenceInSeconds(new Date(), date)

    if (difference < 60) return `${Math.floor(difference)} sec`
    else if (difference < 3600) return `${Math.floor(difference / 60)} min`
    else if (difference < 86400) return `${Math.floor(difference / 3660)} h`
    else if (difference < 86400 * 30)
        return `${Math.floor(difference / 86400)} d`
    else if (difference < 86400 * 30 * 12)
        return `${Math.floor(difference / 86400 / 30)} mon`
    else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`
}

export function generateRandomId() {
    let tempId = Math.random().toString()
    let uid = tempId.substr(2, tempId.length - 1)
    return uid
}

export function getQueryParam(prop) {
    var params = {}
    var search = decodeURIComponent(
        window.location.href.slice(window.location.href.indexOf('?') + 1)
    )
    var definitions = search.split('&')
    definitions.forEach(function (val, key) {
        var parts = val.split('=', 2)
        params[parts[0]] = parts[1]
    })
    return prop && prop in params ? params[prop] : params
}

export function classList(classes) {
    return Object.entries(classes)
        .filter((entry) => entry[1])
        .map((entry) => entry[0])
        .join(' ')
}


export function fullScreenRequest(documentID) {
    if (fscreen.fullscreenElement == null) {
        fscreen.requestFullscreen(document.getElementById(documentID));

        if (document.getElementById(documentID).style.backgroundColor == '') {
            document.getElementById(documentID).style.backgroundColor = "#fffefe"
        } else if (document.getElementById(documentID).style.backgroundColor == "#fffefe") {
            document.getElementById(documentID).style.backgroundColor = '';
        }

        // document.getElementById(documentID).style.backgroundColor = "white"

    } else {

        if (document.getElementById(documentID).style.backgroundColor == "rgb(255, 254, 254)") {
            document.getElementById(documentID).style.backgroundColor = '';
        }
        fscreen.exitFullscreen();
    }
    makedefaultAfterExitFullScreen(documentID)

}


export function fullScreenRequestInsideApp(documentID) {
    let maindiv = document.getElementById("app-fullscreen-1856")
    let childDiv = document.getElementById(documentID)
    //console.log("full screen elemnet", fscreen.fullscreenElement)
    if (fscreen.fullscreenElement != null) {
        if (fscreen.fullscreenElement.id == documentID) {
            fscreen.exitFullscreen();
            if (document.getElementById(documentID).style.backgroundColor == "rgb(255, 254, 254)") {
                document.getElementById(documentID).style.backgroundColor = '';
            }
            //hide in minimum size
            makeHideInSmall()


        } else {
            fscreen.requestFullscreen(document.getElementById(documentID));
            makedefaultAfterExitFullScreen(documentID)
            if (document.getElementById(documentID).style.backgroundColor == '') {
                document.getElementById(documentID).style.backgroundColor = "#fffefe"

            } else if (document.getElementById(documentID).style.backgroundColor == "rgb(255, 254, 254)") {
                //document.getElementById(documentID).style.backgroundColor = '';

            }





            // add globle css to show in fullscreen
            makeShowInFullScreen();


        }


    } else {

        if (maindiv.style.zIndex == 116) {
            maindiv.style.zIndex = -99;
            maindiv.style.display = 'none'
            let beforParentElementid = childDiv.getAttribute("beforParent")
            document.getElementById(beforParentElementid).append(childDiv);

            //hide in minimum size
            makeHideInSmall()



        } else {
            maindiv.style.zIndex = 116;
            maindiv.style.display = 'unset'

            let perentElement = childDiv.parentElement;
            let parentElementID = perentElement.id;
            if (parentElementID == '') {
                parentElementID = makeid();
                perentElement.id = parentElementID;
            }
            childDiv.setAttribute("beforParent", parentElementID)
            maindiv.append(childDiv);

            // add globle css to show in fullscreen
            makeShowInFullScreen();
        }
    }



    // maindiv.classList.add()
}

export function makeid() {
    let length = 5;
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
}

export function makedefaultAfterExitFullScreen(documentID) {
    document.getElementById(documentID).addEventListener('fullscreenchange', (event) => {
        // document.fullscreenElement will point to the element that
        // is in fullscreen mode if there is one. If not, the value
        // of the property is null.
        if (document.fullscreenElement) {
            console.log(`Element: ${document.fullscreenElement.id} entered fullscreen mode.`);
        } else {
            console.log('Leaving full-screen mode.');
            //hide in minimum size
            var style = document.createElement('style');
            style.type = 'text/css';
            if (style.styleSheet) {
                style.styleSheet.cssText = '.show-on-fullScreen{display:none}';
            } else {
                style.appendChild(document.createTextNode('.show-on-fullScreen{display:none}'));
            }
            document.getElementsByTagName('head')[0].appendChild(style);


            if (document.getElementById(documentID).style.backgroundColor == "rgb(255, 254, 254)") {
                document.getElementById(documentID).style.backgroundColor = '';
            }


        }
    });
}

export function makeHideInSmall() {
    //hide in minimum size
    var style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = '.show-on-fullScreen{display:none} .hide-on-fullScreen{display:flex} ';
    } else {
        style.appendChild(document.createTextNode('.show-on-fullScreen{display:none} .hide-on-fullScreen{display:flex} '));
    }
    document.getElementsByTagName('head')[0].appendChild(style);

    var ele = document.getElementsByClassName('widget-container')
    for (let i = 0; i < ele.length; i++) {
        //ele[i].className += " full-height-on-fullScreen";
        ele[i].classList.remove('full-height-on-fullScreen')
    }
}

export function makeShowInFullScreen() {
    var style = document.createElement('style');
    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = '.show-on-fullScreen{display:flex} .hide-on-fullScreen{display:none} ';
    } else {
        style.appendChild(document.createTextNode('.show-on-fullScreen{display:flex} .hide-on-fullScreen{display:none} '));
    }
    document.getElementsByTagName('head')[0].appendChild(style);

    var ele = document.getElementsByClassName('widget-container')
    for (let i = 0; i < ele.length; i++) {
        //ele[i].className += " full-height-on-fullScreen";
        ele[i].classList.add('full-height-on-fullScreen')
    }
    /* document.getElementsByClassName('widget-container').forEach(element => {
        element.classList.add('full-height-on-fullScreen')
    }); */
}

export function addBackgroundColor(documentID) {
    if (document.getElementById(documentID).style.backgroundColor == '') {
        document.getElementById(documentID).style.backgroundColor = "#fffefe"
    } else if (document.getElementById(documentID).style.backgroundColor == "rgb(255, 254, 254)") {
        document.getElementById(documentID).style.backgroundColor = '';
    }
}

export function dateParse(date) {

    return moment(date).format('yyyy-MM-DD');
}

export function dateTimeParse(date) {

    return moment(date).format('yyyy-MM-DD HH:mm:ss');
}
export function timeParse(time){
    return moment(time).format('HH:mm');
}